<template>
  <article data-component="CardResultInline" class="inline">
    <AtomLink
      :url="url"
      class="cursor-pointer text-sm leading-none group bg-white text-black rounded-3xl px-3 py-1 group hover:bg-black hover:text-white cursor-pointer transform transition duration-200 font-medium"
    >
      <p class="c-card-result-header inline">
        {{ title }} <time v-if="when" :datetime="d_(when, 'iso')">({{ d_(when, 'short-date') }})</time>
      </p>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
defineProps({
  url: { type: String, required: true },
  title: { type: String, required: true },
  body: { type: String, required: false, default: undefined },
  mode: { type: String, required: false, default: undefined },
  when: { type: [Date, String], required: false, default: undefined },
})

const { d_ } = setupTranslationPrefixer('CardResultInline')
</script>

<style scoped>
.c-card-result-header {
  /*text-underline-offset: 2px;*/
  /*text-decoration-thickness: 1px;*/
}
</style>
